import type { FC } from "react";

import type { SiteBatchUpdateEntity } from "src/app/features/Site/types/SiteBatchUpdateEntity";
import { SiteGroupBatchUpdateForm } from "src/app/features/SiteGroup/components/forms/SiteGroupBatchUpdateForm";
import { useSiteGroupBatchUpdateMutation } from "src/app/features/SiteGroup/services/server/SiteGroupApi";
import type { SiteGroupEntity } from "src/app/features/SiteGroup/types/SiteGroupEntity";
import { BatchUpdateDrawerButton } from "../../../../../components/DrawerForm/BatchUpdateDrawer/BatchUpdateDrawerButton";
import { useBatchUpdateDrawer } from "../../../../../components/DrawerForm/BatchUpdateDrawer/useBatchUpdateDrawer";
import type { ButtonProps } from "../../../../../components/FeatureButtons/types";

export const SiteGroupBatchUpdateDrawerButton: FC<ButtonProps<SiteGroupEntity>> = ({ isDisabled, items }) => {
    const [saveFormData] = useSiteGroupBatchUpdateMutation();
    const { open, form, isDisabledFinal, isSubmitting, showDrawer, onClose, onSubmit } = useBatchUpdateDrawer<
        SiteBatchUpdateEntity,
        SiteGroupEntity
    >(items, isDisabled, saveFormData);

    return (
        <BatchUpdateDrawerButton
            isDisabled={isDisabledFinal}
            open={open}
            onOpen={showDrawer}
            onClose={onClose}
            isSubmitting={isSubmitting}
            titleKey="siteGroups.batchUpdate.header"
        >
            <SiteGroupBatchUpdateForm form={form} searchCallback={onSubmit} />
        </BatchUpdateDrawerButton>
    );
};
